// import React, { useCallback, useEffect, useRef, useState } from "react";
// import { Check } from "lucide-react";
// import { Task } from "@mui/icons-material";

// const SIZE_MAP = {
//   xs: {
//     box: "w-4 h-4",
//     icon: "w-2.5 h-2.5",
//     burstDistance: 10,
//     borderRadius: "9999px",
//   },
//   small: {
//     box: "w-5 h-5",
//     icon: "w-3 h-3",
//     burstDistance: 12,
//   },
//   medium: {
//     box: "w-6 h-6",
//     icon: "w-3.5 h-3.5",
//     burstDistance: 15,
//     borderRadius: "9999px",
//   },
//   large: {
//     box: "w-8 h-8",
//     icon: "w-5 h-5",
//     burstDistance: 20,
//     borderRadius: "9999px",
//   },
// };

// function TaskRadioButton({ isChecked, size = "medium" }) {
//   const [checked, setChecked] = useState(isChecked);
//   const [hovered, setHovered] = useState(false);
//   const [burst, setBurst] = useState(false);

//   useEffect(() => {
//     if (!burst) return;
//     const t = setTimeout(() => setBurst(false), 1000);
//     return () => clearTimeout(t);
//   }, [burst]);

//   useEffect(() => {
//     console.log("checked changed:", checked);
//     if (checked) {
//       console.log("setting burst to true");
//       setBurst(true);
//     }
//   }, [checked]);

//   const handleClick = () => {
//     console.log("inside handle click for task completion");
//     setChecked((prev) => !prev);
//   };

//   console.log("burst value:", burst);

//   const { box, icon, burstDistance, borderRadius } = SIZE_MAP[size];

//   return (
//     <div className="flex items-center justify-center">
//       <div
//         className={`relative ${box} flex items-center justify-center border-2 rounded-full cursor-pointer transition-all duration-300 overflow-visible ${
//           checked ? "bg-green-500 " : hovered ? "border-green-500 " : "border-gray-400  delete-button"
//         }`}
//         style={{ borderRadius }}
//         onClick={handleClick}
//         onMouseEnter={() => setHovered(true)}
//         onMouseLeave={() => setHovered(false)}
//       >
//       {(checked || hovered) && (
//           <Check
//             className={`${icon} ${checked ? "text-white" : "text-green-500 "} z-999 transition-opacity duration-300`}
//           />
//         )}

//         {false && checked && (
//           <>
//             {/* THIN CONFETTI RIBBONS */}
//             {[...Array(10)].map((_, i) => {
//               const angle = i * 36; // 10 ribbons around 360°
//               const delay = `${i * 0.02}s`;

//               const colors = ["#F43F5E", "#0EA5E9", "#22C55E", "#F59E0B", "#A855F7"];
//               const color = colors[i % colors.length];

//               const style = {
//                 top: "50%",
//                 left: "50%",
//                 position: "absolute",
//                 width: "3px", // 🟢 thinner ribbon
//                 height: `${3 + (i % 3) * 3}px`,
//                 background: color,
//                 transform: "translate(-50%, -50%)",
//                 borderRadius: "1px",
//                 animation: `confettiBurst 600ms cubic-bezier(.25,.7,.2,1) forwards`,
//                 animationDelay: delay,
//                 ["--angle"]: `${angle}deg`,
//                 ["--distance"]: `${burstDistance + 6}px`,
//               };

//               return <span key={`r-${i}`} style={style} />;
//             })}

//             {/* SMALL ROUND PARTICLES */}
//             {[...Array(8)].map((_, i) => {
//               const angle = i * 45;
//               const delay = `${i * 0.015}s`;

//               const style = {
//                 width: "4px",
//                 height: "4px",
//                 top: "50%",
//                 left: "50%",
//                 position: "absolute",
//                 backgroundColor: "rgb(34,197,94)", // green
//                 borderRadius: "9999px",
//                 transform: "translate(-50%, -50%)",
//                 animation: `particleBurst 400ms cubic-bezier(.2,.9,.2,1) forwards`,
//                 animationDelay: delay,
//                 ["--angle"]: `${angle}deg`,
//                 ["--distance"]: `${burstDistance + 10}px`,
//               };

//               return <span key={`p-${i}`} style={style} />;
//             })}

//             {/* INJECT ANIMATION KEYFRAMES ONCE */}
//             <style>
//               {`
//         @keyframes confettiBurst {
//           0% {
//             transform: translate(-50%, -50%) rotate(var(--angle)) translateY(0) scale(1);
//             opacity: 1;
//           }
//           40% {
//             transform: translate(-50%, -50%) rotate(var(--angle)) translateY(calc(-1 * var(--distance))) scale(1.05);
//             opacity: 1;
//           }
//           100% {
//             transform: translate(-50%, calc(-50% + 10px)) rotate(calc(var(--angle) + 40deg))
//                        translateY(calc(var(--distance) * 0.6)) scale(0.8);
//             opacity: 0;
//           }
//         }

//         @keyframes particleBurst {
//           0% {
//             transform: translate(-50%, -50%) rotate(var(--angle)) translateY(0) scale(0.4);
//             opacity: 0.9;
//           }
//           40% {
//             transform: translate(-50%, -50%) rotate(var(--angle)) translateY(calc(-1 * var(--distance))) scale(1);
//             opacity: 1;
//           }
//           100% {
//             transform: translate(-50%, -50%) rotate(var(--angle)) translateY(calc(-1 * var(--distance) * 1.3))
//                         scale(0.4);
//             opacity: 0;
//           }
//         }
//       `}
//             </style>
//           </>
//         )}

//         <style jsx>{`
//           @keyframes zoomDisappear {
//             0% {
//               transform: scale(0.5);
//               opacity: 0;
//             }
//             50% {
//               transform: scale(1);
//               opacity: 1;
//             }
//             100% {
//               transform: scale(0.3);
//               opacity: 0;
//             }
//           }
//         `}</style>
//       </div>
//     </div>
//   );
// }

// export default React.memo(TaskRadioButton, (prevProps, nextProps) => {
//   return prevProps.isChecked === nextProps.isChecked && prevProps.size === nextProps.size;
// });

// old original code
import React, { useEffect, useState } from "react";
import { Check } from "lucide-react";
function TaskRadioButton({ isChecked }) {
  const [checked, setChecked] = useState(isChecked);
  const [hovered, setHovered] = useState(false);
  const [burst, setBurst] = useState(false);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);
  const handleClick = () => {
    setChecked(!checked);
    // setBurst(true);
    // setTimeout(() => setBurst(false), 500);
  };

  return (
    <div className="flex items-center justify-center">
      <div
        className={`relative w-6 h-6 flex items-center justify-center border rounded-full cursor-pointer transition-all duration-300 overflow-visible ${
          checked ? "bg-green-500" : hovered ? "border-green-500" : "border-gray-400"
        }`}
        onClick={handleClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {(checked || hovered) && (
          <Check
            className={`w-3.5 h-3.5 ${checked ? "text-white" : "text-green-500"} z-10 transition-opacity duration-300`}
          />
        )}

        {burst && (
          <>
            {[...Array(8)].map((_, i) => {
              const isLarge = i % 2 === 0;
              return (
                <span
                  key={i}
                  style={{
                    width: isLarge ? "4px" : "2px",
                    height: isLarge ? "4px" : "2px",
                    top: "50%",
                    left: "50%",
                    position: "absolute",
                    backgroundColor: "green", // or whatever fits your design
                    borderRadius: "9999px",
                    transform: `translate(-50%, -50%) rotate(${i * 45}deg) translateY(-15px)`,
                    animation: `zoomDisappear 0.4s ease-in-out forwards`,
                    animationDelay: `${0.05}s`,
                  }}
                />
              );
            })}
          </>
        )}

        <style jsx>{`
          @keyframes zoomDisappear {
            0% {
              transform: scale(0.5);
              opacity: 0;
            }
            50% {
              transform: scale(1);
              opacity: 1;
            }
            100% {
              transform: scale(0.3);
              opacity: 0;
            }
        `}</style>
      </div>
    </div>
  );
}

export default React.memo(TaskRadioButton, (prevProps, nextProps) => {
  return prevProps.isChecked === nextProps.isChecked;
});
